module.exports = __webpack_public_path__ + "img/svg - teachers.ba3eefac.svg";